import {action, observable} from 'mobx';
import { getRoomList, checkRoomStatus } from '@/services/Site';
import { roomTypes } from '@/types/APITypes';
import * as R from 'ramda';

class RoomStore {
  
  @observable roomList: roomTypes [] = []
  
  @observable activeRoom: any
  
  @action.bound async getRoomList () {
    
      const [error, result] = await getRoomList();
    
      if (error) return;
    
      this.roomList = result.roomList;
    
      return result.roomList
    
  }
  
  @action.bound async checkRoomStatus (roomId: number) {
    
      const [error, result] = await checkRoomStatus({roomId: roomId});
  
      if (error || result.roomStatus !== 1) return false;
    
      const activeRoom = R.find(R.propEq('id', roomId))(this.roomList);
    
      this.activeRoom = activeRoom;
    
      window.localStorage.setItem('activeRoom', JSON.stringify(activeRoom))
    
      return true
  
  }
  
  
}

export default RoomStore;
